import { Link, useLocation } from 'react-router-dom';
import { Home, FileText, Store, Wrench, Users, CreditCard, Crown } from 'lucide-react';

const NAV_ITEMS = [
  { label: 'Accueil',            icon: Home,       to: '/cockpit-particulier' },
  { label: 'Présentation',       icon: FileText,   to: '/cockpit-pro/presentation' },
  { label: 'Boutique',           icon: Store,      to: '/cockpit-pro/info-boutique' },
  { label: 'Cockpit Bâtiment',   icon: Wrench,     to: '/cockpit-pro/dashboard' },
  { label: 'Équipe Agents IA',   icon: Users,      to: '/cockpit-pro/agents-ia' },
  { label: 'Tarifs',             icon: CreditCard, to: '/cockpit-pro/tarifs-pro' },
  { label: 'Membre Fondateur',   icon: Crown,      to: '/cockpit-pro/fondateurs' },
];

export default function CockpitProTopNav() {
  const location = useLocation();

  return (
    <div className="hidden lg:block" data-testid="cockpit-pro-top-nav">
      <nav className="bg-gradient-to-r from-orange-50 to-amber-50 border-b border-orange-100">
        <div className="px-6">
          <div className="flex items-center gap-1">
            {NAV_ITEMS.map((item) => {
              const Icon = item.icon;
              const isActive = location.pathname === item.to ||
                (item.to !== '/cockpit-particulier' && location.pathname.startsWith(item.to));

              return (
                <Link
                  key={item.to}
                  to={item.to}
                  className={`flex items-center gap-1.5 px-3 py-3 text-sm font-medium transition-colors relative ${
                    isActive
                      ? 'text-[#E8650A]'
                      : 'text-[#1E3A5F] hover:text-[#E8650A]'
                  }`}
                >
                  <Icon size={16} />
                  <span>{item.label}</span>
                  {isActive && (
                    <span className="absolute bottom-0 left-3 right-3 h-0.5 bg-[#E8650A] rounded-full" />
                  )}
                </Link>
              );
            })}
          </div>
        </div>
      </nav>
    </div>
  );
}
